<template>
  <div class="modal-body relative  w-full flex flex-col h-full">
    <transition
            enter-active-class="transition duration-400 ease-in"
            enter-from-class="opacity-0"
            enter-to-class="opacity-100"
            leave-active-class="transition duration-100 ease-out"
            leave-from-class="opacity-100"
            leave-to-class="opacity-0"
            class="h-full"
        >
            <div v-if="isLoading" class="fixed top-0 bottom-0 left-0 right-0 bg-black/[0.7] flex flex-col justify-center items-center z-40"
                    tabindex="-1" >
                <div class="flex flex-col justify-center items-center p-4 rounded-md">
                <svg aria-hidden="true" class="mx-1 w-8 h-8 text-gray-200 animate-spin dark:text-gray-600"
                    viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                            fill="#d3d3d3"/>
                        <path
                            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                            fill="#2E9CCA"/>
                </svg>
                <div class="text-white p-4 whitespace-nowrap text-sm">
                    Please Wait While We Make Changes To {{ company.company_name }}.
                </div>
                </div>
            </div>
        </transition>
      <div class="h-full overscroll-none">
        <div class="flex w-full justify-between items-center">
            <div  v-if="showCRMEditForm" class="py-3 px-1 rounded w-fit text-sm flex">
                <label class="bg-light-primary border-b border-b-light-primary text-gray-600 py-1 px-2 w-full flex justify-center items-center rounded-l-md h-8 text-center" for="selectedCampaign">Campaign: </label>
                <div class="w-fit whitespace-nowrap  rounded-tr-md rounded-br-md border border-light-primary px-2 flex items-center h-8 bg-gray-100 text-gray-600">
                    {{ currentCampaign }} 
                </div>
            </div>
            <div v-else class="py-3 px-1 rounded w-fit text-sm flex items-center">
                <label class="bg-light-primary border-b border-b-light-primary py-1 px-2 w-full flex justify-center items-center rounded-l-md h-8 text-center">Campaign: </label>
                <Listbox :model-value="selectedCampaign" @update:model-value="val => selectedCampaign = val">
                    <div class="relative">
                        <ListboxButton class="flex items-center rounded-tr-md rounded-br-md border border-light-primary pl-2 pr-7 h-8 bg-white text-gray-900 whitespace-nowrap relative">
                            {{ campaignOptions.find(c => c.id === selectedCampaign)?.campaign_name }}<span v-if="selectedCampaign == currentCompanyCampaignOption.id"> (Current)</span>
                            <span v-if="selectedCampaign != currentCompanyCampaignOption.id && campaignMostRecentStatus[selectedCampaign]" class="text-xs font-medium px-1.5 py-0.5 rounded-full bg-amber-100 text-amber-800 ml-1.5 flex-shrink-0">{{ campaignMostRecentStatus[selectedCampaign].crm_status.status_name }}</span>
                            <span v-else-if="selectedCampaign != currentCompanyCampaignOption.id && campaignIdsWithActions.has(selectedCampaign)" class="w-2 h-2 rounded-full bg-amber-400 ml-1.5 flex-shrink-0 inline-block"></span>
                            <ChevronUpDownIcon class="absolute right-1 h-4 w-4 text-gray-600" />
                        </ListboxButton>
                        <transition leave-active-class="transition duration-100 ease-in" leave-from-class="opacity-100" leave-to-class="opacity-0">
                            <ListboxOptions class="absolute z-30 mt-1 min-w-full w-max overflow-auto rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                                <ListboxOption v-slot="{ active, selected }" v-for="campaign in campaignOptions" :key="campaign.id" :value="campaign.id" as="template">
                                    <li :class="[active ? 'bg-amber-100 text-amber-900' : 'text-gray-900', 'relative cursor-default select-none py-1.5 pl-3 pr-4 flex items-center justify-between gap-2']">
                                        <span :class="selected ? 'font-medium' : 'font-normal'">{{ campaign.campaign_name }}<span v-if="campaign.id == currentCompanyCampaignOption.id"> (Current)</span></span>
                                        <span v-if="campaign.id != currentCompanyCampaignOption.id && campaignMostRecentStatus[campaign.id]" class="text-xs font-medium px-1.5 py-0.5 rounded-full bg-amber-100 text-amber-800 flex-shrink-0">{{ campaignMostRecentStatus[campaign.id].crm_status.status_name }}</span>
                                        <span v-else-if="campaign.id != currentCompanyCampaignOption.id && campaignIdsWithActions.has(campaign.id)" class="w-2 h-2 rounded-full bg-amber-400 flex-shrink-0 inline-block"></span>
                                    </li>
                                </ListboxOption>
                            </ListboxOptions>
                        </transition>
                    </div>
                </Listbox>
            </div>
            <div v-if="numCRMActionsPreviousCampaigns > 0" class="py-2 h-full text-sm">
                <div class="py-1 px-3 rounded-2xl bg-amber-300 border-amber-400 text-amber-900">
                    {{ numCRMActionsPreviousCampaigns }} CRM Details in Other Campaigns
                </div>
            </div>
        </div>
        <div class="border-y border-light-primary ml-3 ">
            <div class="flex justify-between items-center  h-12">
                <h2 class="text-sm tracking-wider font-semibold text-gray-800 flex items-center" v-if="mostRecentStatus">CRM Status:
                    <select v-if="selectedCampaign == currentCompanyCampaign" name="addStatus" id="" class="p-1 border mx-3  border-light-primary w-fit rounded" :value="mostRecentStatus.crm_status.id"  @change="addCrmStatus">
                        <option v-for="option in statusOptions" :key="option.value" :value="option.value" >{{ option.label }} <span v-if="mostRecentStatus.crm_status.id == option.value"> - Updated {{ new Date(mostRecentStatus.created_on).toLocaleDateString() }}</span></option>
                    </select> 
                    <span class="mx-3" v-else>{{ mostRecentStatus.crm_status.status_name }}</span>
                    <span class="flex">
                        <div v-if="loadingCRMStatus" class="flex justify-start items-center space-x-2">                        
                            <svg aria-hidden="true" class="mx-1 w-5 h-5 text-gray-200 animate-spin dark:text-gray-600"
                            viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                    fill="#d3d3d3"/>
                                <path
                                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                    fill="#2E9CCA"/>
                            </svg>
                            <div>
                                Updating CRM Status...
                            </div>
                        </div>
                        <!-- <div v-else>
                            Updated on {{ new Date(mostRecentStatus.created_on).toLocaleDateString() }}
                        </div> -->
                    </span>
                </h2>
                <h2 class="text-sm flex items-center" v-else>CRM Status:
                    <select v-if="company.campaign && selectedCampaign == company.campaign.id" name="addStatus" id="" class="p-1 border mx-3  border-light-primary w-fit rounded"  @change="addCrmStatus">
                        <option value="" disabled selected>--</option>
                        <option v-for="option in statusOptions" :key="option.value" :value="option.value" >{{ option.label }}</option>
                    </select> 
                    <span class="mx-3" v-else>--</span>
                </h2>
                <button v-if="selectedCampaign" class="bg-dark-secondary text-white hover:bg-dark-primary px-2 py-1 rounded" @click="toggleShowAll">{{ showAllStatusesText }}</button>
            </div>
            <base-table v-if="showAllStatuses" class="max-h-72 overflow-y-auto mb-2">
                <template #table-header>
                    <th :key="header.label" class="sticky -top-0.5 p-1 bg-white drop-shadow-sm h-full font-semibold tracking-wide" :class="header.class" v-for="header in statusTableHeadersList">
                        {{ header.label }}
                    </th>
                </template>
                <template  #table-body>
                    <tr  v-for="crm_status in crm_statuses" class="border border-collapse"  :key="crm_status.id">
                        <td class="p-1">
                            {{ crm_status.crm_status.status_name }}
                        </td>
                        <td class="p-1">
                            {{ new Date(crm_status.created_on).toLocaleDateString() }}
                        </td>
                        <td v-if="canDeleteCRMStatus" class="p-1">
                            <div v-if="confirmingStatusId == crm_status.id" class="flex items-center space-x-2 whitespace-nowrap">
                                <span>Delete?</span>
                                <button class="bg-red-600 text-white hover:bg-red-700 px-2 rounded disabled:opacity-50 disabled:cursor-not-allowed" :disabled="deletingStatus" @click="deleteCrmStatus(crm_status.id)">{{ deletingStatus ? 'Deleting...' : 'Confirm' }}</button>
                                <button class="bg-gray-200 hover:bg-gray-300 px-2 rounded disabled:opacity-50 disabled:cursor-not-allowed" :disabled="deletingStatus" @click="confirmingStatusId = null">Cancel</button>
                            </div>
                            <div v-else class="flex">
                                <button class="text-red-600 hover:text-red-800 hover:underline disabled:opacity-50 disabled:cursor-not-allowed disabled:no-underline" :disabled="deletingStatus" @click="confirmingStatusId = crm_status.id">Delete</button>
                            </div>
                        </td>
                        <!-- <td class="p-1">
                            {{ crm_status.crm_status.high_level_grouping_for_report.high_level_grouping_name }}
                        </td> -->
                    </tr>
                </template>
            </base-table>
        </div>
        <div class="h-full ml-3 pb-1 mb-2">
            <div class=" mb-1 flex justify-between items-center h-12">
                <div class="flex items-center space-x-3 px-1">
                    <h2 class="text-sm tracking-wider font-semibold text-gray-800">Details: </h2>
                    <div class="flex space-x-5 w-full justify-start items-center">
                        <div class="flex justify-start items-center w-fit whitespace-nowrap">
                            <div class="mr-1 w-5 h-5 rounded bg-emerald-200 border border-gray-300">

                            </div>
                            <div>
                                Existing Detail
                            </div>
                        </div>
                        <div class="flex justify-start items-center w-fit whitespace-nowrap">
                            <div class="mr-1 w-5 h-5 rounded bg-sky-200 border border-gray-300">

                            </div>
                            <div>
                                Valid Row
                            </div>
                        </div>
                        <!-- <div class="flex justify-start items-center w-fit whitespace-nowrap">
                            <div class="mr-1 w-5 h-5 rounded bg-amber-100 border border-gray-300">

                            </div>
                            <div>
                                Empty Row
                            </div>
                        </div> -->
                        <div class="flex justify-start items-center w-fit whitespace-nowrap">
                            <div class="mr-1 w-5 h-5 rounded bg-red-400 border border-gray-300">

                            </div>
                            <div>
                                Invalid Row
                            </div>
                        </div>
                    </div>
                    <div class="flex items-center">
                        <h2 class="text-sm tracking-wider font-semibold whitespace-nowrap text-gray-800">
                            Scott Spreadsheet View:
                        </h2>
                        <input type="checkbox" @change="saveShowOnSpreadsheetView" class="ml-2" v-model="showOnSpreadsheetView" >
                    </div> 
                    <div class="flex items-center">
                        <h2 class="text-sm tracking-wider font-semibold whitespace-nowrap text-gray-800">
                            My Spreadsheet View:
                        </h2>
                        <input type="checkbox" @change="saveShowOnMySpreadsheetView" class="ml-2" v-model="showOnMySpreadsheetView" >
                    </div> 
                
                </div>
                <div v-if="company.campaign && selectedCampaign == company.campaign.id">
                    <button v-if="showCRMEditForm" class="bg-dark-secondary text-white hover:bg-dark-primary px-2 py-1 rounded" @click="closeCRMEditForm">Cancel</button>
                    <div v-else class=" flex justify-end items-center space-x-2">
                        <button class="bg-dark-secondary text-white px-2 py-1 rounded" @click="openCRMEditForm">Edit</button>
                    </div>
                </div>
                <div v-else class="h-9"></div>
            </div>
            <div class="flex justify-between h-full" v-if="showCRMEditForm">
                <CRMEditForm 
                    :company="company"
                    :crmEventTypeOptions="crmEventTypeOptions"
                    :companyCampaignId="companyCampaignId"
                    :userOptions="userOptions"
                    :emptyCRMActions="emptyCRMActions"
                    @update-crm-events="bulkUpdateCompanyCRM"
                    @update-crm-events-and-close="bulkUpdateCompanyCRMAndClose"
                    @close-crm-edit-form="closeCRMEditForm"
                />
            </div>
            <div v-else class="h-full">
                <div class="w-full grid grid-cols-12 border-gray-300 rounded-t overflow-y-scroll ">
                    <div class="w-full bg-gray-50 border-y border-r border-l col-span-1 rounded-tl border-gray-300 px-3 py-1.5 font-semibold">
                        Reorder
                    </div>
                    <div class="w-full bg-gray-50 border-y border-r border-l col-span-2 border-gray-300 px-3 py-1.5 font-semibold">
                        Detail
                    </div>
                    <div class="w-full bg-gray-50 border-y border-r col-span-2 border-gray-300 px-3 py-1.5 font-semibold">
                        Due Date
                    </div>
                    <div class="w-full bg-gray-50 border-y border-r col-span-2 border-gray-300 px-3 py-1.5 font-semibold">
                        Resolved Date
                    </div>
                    <div class="w-full bg-gray-50 border-y border-r col-span-1 border-gray-300 px-3 py-1.5 font-semibold">
                        Owner (Created By)
                    </div>
                    <div class="w-full text-center bg-gray-50 border-y border-r col-span-1 border-gray-300 px-3 py-1.5 font-semibold">
                        Status
                    </div>
                    <div class="w-full bg-gray-50 border-y border-r col-span-2 border-gray-300 px-3 py-1.5 font-semibold">
                        Notes
                    </div>
                    <div class="w-full flex justify-center bg-gray-50 border-y border-r col-span-1 rounded-tr border-gray-300 px-3 py-1.5 font-semibold">
                        Corresp.
                    </div>
                </div>
                <div class="overflow-y-scroll h-96  max-h-[calc(100vh-13.5rem)] ">
                    <TransitionGroup name="events">
                        <CRMEventRowReadOnly class="draggableRow transition-all duration-100" :ondragstart="dragstartOpenDetailHandler" :ondragend="dragEndHandler" :ondrop="dropOpenDetailHandler"  :ondragover="dragoverOpenDetailHandler" :ondragleave="dragLeaveHandler"
                            draggable="true" :data-value="action.ordinal" :id="action.id" :drag-due-date="action.due_date"
                            v-for="action in openActions"
                            :key="action.id"
                            :event="action"
                            :is-dragging="isDragging"
                            :dragging-due-date="draggingDueDate"
                        />
                        <CRMEventRowReadOnly class="draggableRow transition-all duration-100" :ondragstart="dragstartResolvedDetailHandler" :ondragend="dragEndHandler" :ondrop="dropResolvedDetailHandler"  :ondragover="dragoverResolvedDetailHandler" :ondragleave="dragLeaveHandler"
                            draggable="true" :data-value="event.ordinal" :id="event.id" :drag-resolved-date="event.resolved_date"
                            v-for="event in events"
                            :key="event.id"
                            :event="event"
                            :is-dragging="isDragging"
                            :dragging-resolved-date="draggingResolvedDate"
                        />
                    </TransitionGroup>
                </div>
            </div>
        </div>
      </div>
  </div>
</template>

<script>
    export default {
        name: 'crm-details-page'
    }
</script>

<style>
.eventTable-enter-active,
.eventTable-leave-active {
  transition: all 0.5s ease;
}
.eventTable-enter-from,
.eventTable-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
</style>

<script setup>
import { defineProps, ref, computed, watch, defineEmits, onMounted} from 'vue';
import { useStore } from 'vuex';
import { addNewCrmStatus, addNewCrmAction, removeCrmStatus } from '@/services/Company';
import {deleteAction, bulkUpdateOrdinals } from '@/services/CrmAction'
import { getCRMStatusGroups, getComputedCRMStatusByEventId, assignCRMDetailOrdinals, sortCRMDetailsByDueDate, sortCRMDetailsByResolvedDate } from '@/composables/CompanyCRMTools';
import { getUsers } from '@/services/User';
import CRMEditForm from './company/CRMEditForm.vue';
import CRMEventRowReadOnly from './company/CRMEventRowReadOnly.vue';
import { updateCompanyCRMActions, updateCompany, addOrRemoveCRMSpreadsheetUser } from '@/services/Company';
import { useToast } from 'vue-toast-notification';
import { Listbox, ListboxButton, ListboxOptions, ListboxOption } from '@headlessui/vue';
import { ChevronUpDownIcon } from '@heroicons/vue/20/solid';

const store = useStore()
const $toast = useToast()

const props = defineProps({
    company: Object,
    campaigns: Array,
    crmStatuses: Array,
    crmActionTypes: Array,
    openInEdit: Boolean,
    defaultCampaign: Number
})

const emit = defineEmits(['refetch-companies', 'updated', 'close', 'loading-company', 'company-loaded', 'save-and-close'])

const formRows = ref([])

const showCRMEditForm = ref(props.openInEdit)

const isLoading = ref(false)

const userId = computed(() => {
    return store.state.auth.user.id
})

const loadingCRMStatus = ref(false)

const showOnSpreadsheetView = ref(props.company ? !!props.company.show_on_spreadsheet_view : false)

const showOnMySpreadsheetView = ref(props.company ? !!props.company.crm_spreadsheet_users.map(user => user.id).includes(userId.value) : false)


const crmEventTypes = ref(props.crmActionTypes.filter(crmAction => crmAction.resolved_type == 'event'))

const crmEventTypeOptions = computed(() => {
    let eventTypeOptions = []
    const eventTypeGroups = getCRMStatusGroups()
    eventTypeGroups.forEach((eventTypeGroup) => {
        eventTypeOptions.push({
            ...eventTypeGroup,
            options: props.crmActionTypes.filter((crmActionType) => { return getComputedCRMStatusByEventId(crmActionType.id).label == eventTypeGroup.label})
        })
    })
    return eventTypeOptions
})

watch(() => props.openInEdit, () => {
    if(props.openInEdit){
        openCRMEditForm()
    }
})


const userOptions = ref([
    {value: null, label: 'None'}
])

async function removeAction(actionId) {
    isLoading.value = true
    const token = store.state.auth.token
    await deleteAction(actionId, token)
    emit('refetch-companies')
}

const statusTableHeadersList = computed(() => {
    if(canDeleteCRMStatus.value) {
        return [
            {class: 'w-4/12', label: 'Status'},
            {class: 'w-4/12', label: 'Status Date'},
            {class: 'w-screen', label: 'Actions'},
        ]
    }
    return [
        {class: 'w-screen', label: 'Status'},
        {class: 'w-screen', label: 'Status Date'},
    ]
})

function openCRMEditForm() {
    showCRMEditForm.value = true
}

function closeCRMEditForm() {
    showCRMEditForm.value = false
}

function addFormRow(){
    formRows.value.push(
        {key: Math.random(), company: props.company}
        )
}

function closeActionRow(index) {
    formRows.value.splice(index, 1)
}

const eventsTableHeadersList = ref([
    // {class: "w-3/14", label: 'Task Name'},
    {class: "w-2/12", label: 'Event'},
    // {class: "w-1/14", label: 'Event Status'},
    {class: "w-1/12 text-center", label: 'Event Date'},
    // {class: "w-1/14", label: 'Task Due Date'},
    // {class: "w-1/14", label: 'Task Status'},
    {class: "w-1/12 text-center", label: 'User'},
    // {class: "w-1/14", label: 'Task Resolved Date'},
    {class: "w-6/12", label: 'Event Summary Notes'},
    // {class: "w-5/14", label: 'Task Notes'},
    {class: "w-1/12 text-center", label: 'Event Details'},
    // {class: "w-2/14", label: 'Task Details'},
    {class: "w-1/12 text-center", label: 'Delete'},
])

const showAllStatuses = ref(false)

function toggleShowAll() {
    showAllStatuses.value = !showAllStatuses.value
}

const showAllStatusesText = computed(() => {
    if(showAllStatuses.value){
        return "Hide History"
    } else {
        return "Show History"
    }
})

const currentCompanyCampaign = computed(() => {
    if(props.defaultCampaign){
        return props.defaultCampaign
    }
    if(props.company.campaign){
        return props.company.campaign.id 
    } else {
        return null
    }
})

const currentCompanyCampaignOption = computed(() => {
    if(props.company.campaign){
        return props.company.campaign
    } else {
        return {
            campaign_name: "None",
            id: null
        }
    }
})


const selectedCampaign = ref(currentCompanyCampaign.value)

watch(selectedCampaign, ()=> {
    setEvents()
    setOpenActions()
    setOrdinals()
})

const eventStatus = ref('')

const emptyCRMActions = ref([])

const campaignOptions = ref([])

const currentCampaign = computed(() => {
    return props.company.campaign ? `${props.company.campaign.campaign_name} (Current)` : 'No Campaign'
})

const companyCampaignId = computed(() => {
    return props.company.campaign ? props.company.campaign.id : null
})

const crm_statuses = computed(() => {
    return props.company.crm_statuses.filter(crm_status => crm_status.campaign.id == selectedCampaign.value).sort((a, b) => {
        return new Date(b.created_on) - new Date(a.created_on)
    })
})

const numCRMActionsPreviousCampaigns = computed(() => {
    return props.company.crm_actions.filter(action => action.campaign.id != selectedCampaign.value).length
})

const campaignIdsWithActions = computed(() => {
    return new Set(props.company.crm_actions.map(action => action.campaign.id))
})

const campaignMostRecentStatus = computed(() => {
    const map = {}
    for (const status of props.company.crm_statuses) {
        const cid = status.campaign.id
        if (!map[cid] || new Date(status.created_on) > new Date(map[cid].created_on)) {
            map[cid] = status
        }
    }
    return map
})

const mostRecentStatus = computed(() => {
    if(crm_statuses.value.length > 0){
        let recentStatus = crm_statuses.value.reduce((accumulator, currentValue) =>{
                let accDate = new Date(accumulator.created_on).getTime()
                let currDate = new Date(currentValue.created_on).getTime()
                if(accDate > currDate){
                    return accumulator
                } else {
                    return currentValue
                }
            })
        // console.log('recent status', recentStatus)
        return recentStatus
    } else {
        return null
    }
})

const events = ref([])

function setEvents(){
    let eventList = props.company.crm_actions.filter(action => action.campaign.id == selectedCampaign.value).filter(action => action.resolved_date).sort(sortCRMDetailsByResolvedDate)

    // if(eventStatus.value && eventStatus.value != "Overdue"){
    //     // console.log('eventstatus', eventStatus.value)
    //     eventList = eventList.filter(event => event.status == eventStatus.value)
    // } else if (eventStatus.value && eventStatus.value == "Overdue"){
    //     eventList = eventList.filter((event) => {
    //         const dueDate = new Date(event.resolved_date).getTime()
    //         const today = new Date().getTime()
    //         return event.status == "Open" && today > dueDate
    //     })
    // }
    events.value = eventList
    // console.log('event list', events.value)
}

setEvents()

const openActions = ref([])


function setOrdinals(){
    assignCRMDetailOrdinals(openActions.value)
    assignCRMDetailOrdinals(events.value)
}

function setOpenActions() {
    let openActionList = props.company.crm_actions.filter(action => action.campaign.id == selectedCampaign.value).filter(action => !action.resolved_date).sort(sortCRMDetailsByDueDate)
    openActions.value =  openActionList
}

setOpenActions()
setOrdinals()

watch(() => props.company, () => {
    setEvents()
    setOpenActions()
    setOrdinals()
})

onMounted(() => {
    calculateEmptyCRMEvents()
})

function calculateEmptyCRMEvents() {
    let existingCRMActionTypes = [...new Set(events.value.filter(event => event.campaign.id == companyCampaignId.value).map(event => event.action.id))]
    emptyCRMActions.value = []
    for(let actionType of crmEventTypes.value) {
        if(!existingCRMActionTypes.includes(actionType.id)){
            emptyCRMActions.value.push({
                action: actionType,
                action_id: actionType.id,
                action_notes: null,
                user_id: null,
                resolved_date: null,
                action_details: null,
                type: 3,
                id: Math.floor(Math.random() * -100000),
            })
        }
    }
}

function getCampaignOptions(){
    const campaignIds = props.company.previous_campaigns.map(campaign => campaign.id)
    let filteredCampaigns = [currentCompanyCampaignOption.value, ...props.campaigns.filter(campaign => campaignIds.includes(campaign.id) && campaign.id != currentCompanyCampaignOption.value.id) ]
    if(selectedCampaign.value && !filteredCampaigns.some(campaign => campaign.id == selectedCampaign.value)){
        const missingCampaign = props.campaigns.find(campaign => campaign.id == selectedCampaign.value)
        if(missingCampaign){
            filteredCampaigns.push(missingCampaign)
        }
    }
    campaignOptions.value = filteredCampaigns

}

const statusOptions = ref(
    [
        ...props.crmStatuses.map((status)=>{
            return {'value': status.id, 'label': status.status_name}
        })
    ]
)

async function addCrmStatus(event){
    loadingCRMStatus.value = true
    const token = store.state.auth.token
    const response = await addNewCrmStatus(props.company.id, event.target.value, token)
    if(response.status == 200) {
        emit('refetch-companies')
        $toast.open({
            message: `Successfully Updated CRM Status for Company ${props.company.id}.`,
            type: 'success',
            duration: 5000
        })
    }
    loadingCRMStatus.value = false
}

const userPermissions = computed(() => store.getters['auth/showUserPermissions'] || {})

const canDeleteCRMStatus = computed(() => {
    const permissions = userPermissions.value
    const canEditCRM = permissions.isDev || permissions.isAccountManager || permissions.isManagement || permissions.isSuperuser || permissions.isAccountStaff
    return canEditCRM && companyCampaignId.value && selectedCampaign.value == companyCampaignId.value
})

const confirmingStatusId = ref(null)
const deletingStatus = ref(false)

async function deleteCrmStatus(companyCrmStatusId) {
    deletingStatus.value = true
    const token = store.state.auth.token
    const response = await removeCrmStatus(props.company.id, companyCrmStatusId, token)
    if(response && response.status == 204) {
        emit('refetch-companies')
        $toast.open({
            message: `Successfully Deleted CRM Status for Company ${props.company.id}.`,
            type: 'success',
            duration: 5000
        })
    }
    confirmingStatusId.value = null
    deletingStatus.value = false
}

function validateCRMActionRows(actionRows) {
    let invalidCRMActionRows = []
    let validCRMActionRows = []
    for(let actionRow of actionRows) {
        if(actionRow.action_id) {
            validCRMActionRows.push(actionRow)
        } else {
            invalidCRMActionRows.push(actionRow)
        }
    }
    if(invalidCRMActionRows.length > 0) {
        alert(`Validation Error: Found ${invalidCRMActionRows.length} invalid row(s). Please fix before continuing.`)
        return null
    }
    return validCRMActionRows
}

async function bulkUpdateCompanyCRM(companyCRMActions) {
    isLoading.value = true 
    // console.log('bulkUpdateCompanyCRM', props.company.id)
    let actionRows = validateCRMActionRows(companyCRMActions)
    if(actionRows) {
        const payload = {
            token: store.state.auth.token,
            formData: JSON.stringify(
            {
                crm_actions: actionRows
            }),
            companyId: props.company.id
        }
        // console.log('payload')
        // console.log(payload)
        const response = await updateCompanyCRMActions(payload)
        closeCRMEditForm()
        if(response.status == 200) {
            fetchNewCompanies()
            emit('updated')
            $toast.open({
                message: `Successfully Updated CRM Events for Company ${props.company.id}.`,
                type: 'success',
                duration: 5000
            })
        } else {
            $toast.open({
                message: `Unable to Update CRM Events for Company ${props.company.id}`,
                type: 'error',
                duration: 20000
            })
        }
    } else {
        isLoading.value = false
    }

}

async function updateDetailsOrdinals(crmDetails){
    const token = store.state.auth.token
    const data = {
        crm_details: crmDetails
    }
    const result = await bulkUpdateOrdinals(data, token)
    if(result.status == 200){
        return
    } else {
        $toast.open({
            message: "Error, could not re-order details",
            type: "error",
            duration: 3000
        })
    }

}

async function bulkUpdateCompanyCRMAndClose(companyCRMActions) {
    // console.log('save and close')
    // isLoading.value = true 
    // console.log('bulkUpdateCompanyCRM', props.company.id)
    let actionRows = validateCRMActionRows(companyCRMActions)
    
    if(actionRows) {
        emit('save-and-close', actionRows)
    } else {
        isLoading.value = false
    }

}

function fetchNewCompanies(){
    isLoading.value = true
    emit('refetch-companies')
}

watch(props, () => {
    if(props.company){
        isLoading.value = false
    }
})

watch(()=> events.value, ()=> {
    calculateEmptyCRMEvents()
}, {deep: true})

async function setUserOptions() {
    let payload = {
        token: store.state.auth.token,
        endpoint: '?group_id=1&group_id=7&group_id=8&exclude_dev=True&is_active=True'
    }
    const result = await getUsers(payload)
    userOptions.value = [{value: null, label: 'None'}, ...result.users.map((user) => {
        return { value: user.id, label: `${user.first_name} ${user.last_name}`}
    })]
}

async function saveShowOnMySpreadsheetView(){
    const token = store.state.auth.token
    isLoading.value = true 
    const formData = {
        user_id: userId.value,
        add_user: showOnMySpreadsheetView.value
    }
    const response = await addOrRemoveCRMSpreadsheetUser(token, formData, props.company.id)
    if(response.status == 200) {
        emit('refetch-companies')
        $toast.open({
            message: `Successfully Updated Show on My Spreadsheet View for ${props.company.company_name}.`,
            type: 'success',
            duration: 5000
        })
    }
    isLoading.value = false

}

async function saveShowOnSpreadsheetView(){
    const token = store.state.auth.token
    // console.log('should show?', showOnSpreadsheetView.value)
    isLoading.value = true
    const formData = {
        show_on_spreadsheet_view: showOnSpreadsheetView.value ? 1.0000000000000000 : null
    }
    const response = await updateCompany(props.company.id, formData, token)
    if(response.status == 200) {
        emit('refetch-companies')
        $toast.open({
            message: `Successfully Updated Show on Scott Spreadsheet View for ${props.company.company_name}.`,
            type: 'success',
            duration: 5000
        })
    }
    isLoading.value = false
}


// function orderEvents(){
//     orderedEvents.value = crmEvents.value.filter((detail) => detail.resolved_date && detail.type == 1).sort((a, b) => {
//         return a.type - b.type
//     })
//     orderedOpenDetails.value = crmEvents.value.filter((detail) => !detail.resolved_date).sort((a, b) => {
//         return sortByDueDate(a, b)
//     })
//     // newDetails.value = crmEvents.value.filter((detail) => detail.type != 1).sort((a, b) => {
//     //     return a.type - b.type || sortByDueDate(a, b)
//     // })
//     setOrdinals()
// }

// orderEvents()

const isDragging = ref(false)
const draggingId = ref(null)
const draggingDueDate = ref(null)
const draggingResolvedDate = ref(null)

function dragoverOpenDetailHandler(ev) {
    ev.preventDefault();
    let target = ev.currentTarget
    const targetDueDate = target.getAttribute("drag-due-date")
    if(targetDueDate == draggingDueDate.value){
        target.classList.add("border")
        target.classList.add("border-dark-primary")
        const currentDragElementOffset = ev.clientY
        const targetDragElementRectangle = ev.currentTarget.getBoundingClientRect()
        const targetDragElementOffset = targetDragElementRectangle.y + (targetDragElementRectangle.height / 2)
        if(currentDragElementOffset < targetDragElementOffset){
            ev.currentTarget.classList.add("translate-y-2")
        }
        if(currentDragElementOffset > targetDragElementOffset){
            ev.currentTarget.classList.add("-translate-y-2")
        }
    }
    ev.dataTransfer.dropEffect = "move"
  }

function dragoverResolvedDetailHandler(ev) {
    ev.preventDefault();
    let target = ev.currentTarget
    const targetResolvedDate = target.getAttribute("drag-resolved-date")
    if(targetResolvedDate == draggingResolvedDate.value){
        target.classList.add("border")
        target.classList.add("border-dark-primary")
        const currentDragElementOffset = ev.clientY
        const targetDragElementRectangle = ev.currentTarget.getBoundingClientRect()
        const targetDragElementOffset = targetDragElementRectangle.y + (targetDragElementRectangle.height / 2)
        if(currentDragElementOffset < targetDragElementOffset){
            ev.currentTarget.classList.add("translate-y-2")
        }
        if(currentDragElementOffset > targetDragElementOffset){
            ev.currentTarget.classList.add("-translate-y-2")
        }
    }
    ev.dataTransfer.dropEffect = "move"
  }

function dragLeaveHandler(ev) {
    ev.preventDefault();
    let target = ev.currentTarget
    target.classList.remove("border")
    target.classList.remove("border-dark-primary")
    target.classList.remove("translate-y-2")
    target.classList.remove("-translate-y-2")
  }

  function dropOpenDetailHandler(ev) {
    ev.preventDefault();
    isDragging.value = false
    const currentDragElementOffset = ev.clientY
    const targetDragElementRectangle = ev.currentTarget.getBoundingClientRect()
    const targetDragElementOffset = targetDragElementRectangle.y + (targetDragElementRectangle.height / 2)
    const targetCrmOrdinal = ev.currentTarget.getAttribute("data-value")
    const targetId = ev.currentTarget.getAttribute("id")
    let data = ev.dataTransfer.getData("text/plain");
    data = JSON.parse(data)
    let draggingRow = props.company.crm_actions.find((row) => row.id == draggingId.value)
    let dropRow = props.company.crm_actions.find((row) => row.id == ev.currentTarget.id)
    if(draggingRow.id != dropRow.id && currentDragElementOffset < targetDragElementOffset && (draggingRow.due_date == dropRow.due_date || (!draggingRow.due_date && !dropRow.due_date))){
        let openDetail = openActions.value.find((row) => row.id == draggingId.value)
        if(openDetail){
            // ev.currentTarget.classList.add("translate-y-2")
            let draggingRowIdx = openActions.value.findIndex((row) => row.id == draggingId.value)
            openActions.value.splice(draggingRowIdx, 1)
            let dropRowIdx = openActions.value.findIndex((row) => row.id == ev.currentTarget.id)
            openActions.value.splice(dropRowIdx, 0, openDetail)
        }
    } else if(draggingRow.id != dropRow.id && currentDragElementOffset > targetDragElementOffset && (draggingRow.due_date == dropRow.due_date || (!draggingRow.due_date && !dropRow.due_date))){
        let openDetail = openActions.value.find((row) => row.id == draggingId.value)
        if(openDetail){
            // ev.currentTarget.classList.add("-translate-y-2")
            let draggingRowIdx = openActions.value.findIndex((row) => row.id == draggingId.value)
            openActions.value.splice(draggingRowIdx, 1)
            let dropRowIdx = openActions.value.findIndex((row) => row.id == ev.currentTarget.id)
            openActions.value.splice(dropRowIdx + 1, 0, openDetail)
        }
    }
    // console.log('drag row after', draggingRow)
    // console.log('drop row after', dropRow)
    setOrdinals()
    draggingId.value = null
    ev.currentTarget.classList.remove('border')
    ev.currentTarget.classList.remove('border-dark-primary')
    ev.currentTarget.classList.remove("translate-y-2")
    ev.currentTarget.classList.remove("-translate-y-2")
    updateDetailsOrdinals(openActions.value)
    // orderEvents()
  }

  function dropResolvedDetailHandler(ev) {
    ev.preventDefault();
    isDragging.value = false
    // console.log('current target', ev.currentTarget)
    const currentDragElementOffset = ev.clientY
    const targetDragElementRectangle = ev.currentTarget.getBoundingClientRect()
    const targetDragElementOffset = targetDragElementRectangle.y + (targetDragElementRectangle.height / 2)
    const targetCrmOrdinal = ev.currentTarget.getAttribute("data-value")
    const targetId = ev.currentTarget.getAttribute("id")
    let data = ev.dataTransfer.getData("text/plain");
    data = JSON.parse(data)
    // console.log('data', data)
    let draggingRow = props.company.crm_actions.find((row) => row.id == draggingId.value)
    let dropRow = props.company.crm_actions.find((row) => row.id == ev.currentTarget.id)
    // console.log('draggingrow', draggingRow)
    // console.log('drop row', dropRow)
    if(draggingRow.id != dropRow.id && currentDragElementOffset < targetDragElementOffset && draggingRow.resolved_date == dropRow.resolved_date){
        let resolvedDetail = events.value.find((row) => row.id == draggingId.value)
        if(resolvedDetail){
            // ev.currentTarget.classList.add("translate-y-2")
            let draggingRowIdx = events.value.findIndex((row) => row.id == draggingId.value)
            events.value.splice(draggingRowIdx, 1)
            let dropRowIdx = events.value.findIndex((row) => row.id == ev.currentTarget.id)
            events.value.splice(dropRowIdx, 0, resolvedDetail)
        }
    } else if(draggingRow.id != dropRow.id && currentDragElementOffset > targetDragElementOffset && draggingRow.resolved_date == dropRow.resolved_date){
        let resolvedDetail = events.value.find((row) => row.id == draggingId.value)
        if(resolvedDetail){
            // ev.currentTarget.classList.add("-translate-y-2")
            let draggingRowIdx = events.value.findIndex((row) => row.id == draggingId.value)
            events.value.splice(draggingRowIdx, 1)
            let dropRowIdx = events.value.findIndex((row) => row.id == ev.currentTarget.id)
            events.value.splice(dropRowIdx + 1, 0, resolvedDetail)
        }
    }
    // console.log('drag row after', draggingRow)
    // console.log('drop row after', dropRow)
    setOrdinals()
    draggingId.value = null
    ev.currentTarget.classList.remove('border')
    ev.currentTarget.classList.remove('border-dark-primary')
    ev.currentTarget.classList.remove("translate-y-2")
    ev.currentTarget.classList.remove("-translate-y-2")
    updateDetailsOrdinals(events.value)
    // orderEvents()
  }

function dragstartOpenDetailHandler(ev) {
    draggingId.value = ev.target.id
    // const companyId = ev.target.id
    isDragging.value = true
    // console.log('drag starting with id', ev.target.id)
    ev.dataTransfer.effectAllowed = "move";
    ev.dataTransfer.dropEffect = "move"
    const crmDetailOrdinal = ev.target.getAttribute('data-value')
    let draggingRow = props.company.crm_actions.find((row) => row.id == ev.target.id)
    draggingDueDate.value = draggingRow.due_date
    ev.dataTransfer.setData("text/plain", JSON.stringify({crmDetailId: ev.target.id, crmDetailOrdinal: crmDetailOrdinal}));
}

function dragstartResolvedDetailHandler(ev) {
    draggingId.value = ev.target.id
    // const companyId = ev.target.id
    isDragging.value = true
    // console.log('drag starting with id', ev.target.id)
    ev.dataTransfer.effectAllowed = "move";
    ev.dataTransfer.dropEffect = "move"
    const crmDetailOrdinal = ev.target.getAttribute('data-value')
    let draggingRow = props.company.crm_actions.find((row) => row.id == ev.target.id)
    draggingResolvedDate.value = draggingRow.resolved_date
    ev.dataTransfer.setData("text/plain", JSON.stringify({crmDetailId: ev.target.id, crmDetailOrdinal: crmDetailOrdinal}));
}

function dragEndHandler(ev) {
    // console.log('drag ended')
    isDragging.value = false
    draggingId.value = null
    draggingDueDate.value = null
    draggingResolvedDate.value = null
    ev.currentTarget.classList.remove('border')
    ev.currentTarget.classList.remove('border-dark-primary')
    ev.currentTarget.classList.remove("translate-y-2")
    ev.currentTarget.classList.remove("-translate-y-2")
}

getCampaignOptions()
setUserOptions()
</script>

<style scoped>
.events-move,
.events-enter-active {
    transition: all 0.1s ease;
}
.events-leave-active {
  transition: all 0.08s ease;
}
.events-enter-from,
.events-leave-to {
  opacity: 0;
  transform: translateX(-10px);
}

.events-leave-active {
    position: relative;
    /* position: relative; */
}
</style>